import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslationService } from 'src/app/my-sedgwick';
import { TranslationRequest } from '../models/translation/translation-request';

@Injectable()
export class CustomPaginatorIntl extends MatPaginatorIntl {
  translationRequest = new TranslationRequest({
    language: sessionStorage.getItem('languagepreference'),
    key: null,
    contNum: 0,
    tableName: null,
    primaryKey: null,
    primaryValue: null,
    lob: null,
    group: 'Shared',
    subGroup: 'Shared',
  });
  
  constructor(private translationService: TranslationService) {
    super();
      this.translationService.getTranslationForKey$('Items per page', this.translationRequest).subscribe((translation) => {
        this.itemsPerPageLabel = translation + ':';
        this.changes.next();
      });

      this.translationService.getTranslationForKey$('First page', this.translationRequest).subscribe((translation) => {
        this.firstPageLabel = translation + ':';
        this.changes.next();
      });

      this.translationService.getTranslationForKey$('Last page', this.translationRequest).subscribe((translation) => {
        this.lastPageLabel = translation + ':';
        this.changes.next();
      });

      this.translationService.getTranslationForKey$('Next page', this.translationRequest).subscribe((translation) => {
        this.nextPageLabel = translation + ':';
        this.changes.next();
      });

      this.translationService.getTranslationForKey$('Previous page', this.translationRequest).subscribe((translation) => {
        this.previousPageLabel = translation + ':';
        this.changes.next();
      });

  }
}